import React from 'react';
import PropTypes from 'prop-types';
import { Button, Overlay } from '@thd-olt-component-react/core-ui';

const ConfirmDialog = ({
  children,
  open,
  onConfirm,
  onClose,
  onCloseButtonX,
  headerText,
  confirmText,
  cancelText,
  dataAutoId,
  confirmTestId,
  dataAutoClass
}) => {
  return (
    <Overlay
      modalClass="p2p-overlay p2p-overlay--no-scrollbar p2p-overlay--alt-pos-center p2p-confirm-dialog p2p-confirm-dialog__overwrite-back-button"
      closeButton
      positionedCloseButton
      onClose={onCloseButtonX ?? onClose}
      open={open}
      data-auto-id={dataAutoId}
      data-auto-class={dataAutoClass}
    >
      <div className="p2p-confirm-dialog__header">{headerText}</div>

      <div className="p2p-confirm-dialog__text">{children}</div>

      <div className="p2p-confirm-dialog__buttons">
        <Button
          inline
          link
          onClick={onClose}
          style={{ fontSize: '16px', lineHeight: '20px', color: '#F96302', fontWeight: 'bold' }}
        >
          {cancelText}
        </Button>
        <Button
          {...(confirmTestId ? { 'data-testid': confirmTestId } : {})}
          inline
          onClick={onConfirm}
        >
          {confirmText}
        </Button>
      </div>
    </Overlay>
  );
};

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onCloseButtonX: PropTypes.func,
  headerText: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  dataAutoId: PropTypes.string,
  confirmTestId: PropTypes.string,
  dataAutoClass: PropTypes.string
};

ConfirmDialog.defaultProps = {
  headerText: '',
  confirmText: 'Confirm',
  cancelText: 'Cancel',
  dataAutoId: '',
  confirmTestId: '',
  dataAutoClass: '',
  onCloseButtonX: null
};

export default ConfirmDialog;
